import { usePublish } from '@/contexts/PublishContext';
import { X, CheckCircle2, AlertCircle } from 'lucide-react';
import SciFiLoader from '@/components/ui/SciFiLoader';

const PublishProgress = () => {
  const { currentTask, dismissTask } = usePublish();

  if (!currentTask) return null;

  return (
    <div className="fixed bottom-20 left-4 right-4 z-50 mx-auto max-w-sm animate-slide-up">
      <div className="rounded-2xl border border-border bg-card/95 p-4 shadow-[0_8px_32px_rgba(0,0,0,0.4)]">
        <div className="flex items-center gap-3">
          {currentTask.status === 'uploading' && <SciFiLoader size="sm" inline />}
          {currentTask.status === 'success' && <CheckCircle2 className="w-5 h-5 text-emerald-400 flex-shrink-0" />}
          {currentTask.status === 'error' && <AlertCircle className="w-5 h-5 text-destructive flex-shrink-0" />}

          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-foreground truncate">{currentTask.message}</p>
            {currentTask.status === 'uploading' && (
              <p className="text-xs text-muted-foreground mt-0.5">{currentTask.progress}%</p>
            )}
          </div>

          {currentTask.status !== 'uploading' && (
            <button onClick={dismissTask} className="p-1">
              <X className="w-4 h-4 text-muted-foreground" />
            </button>
          )}
        </div>

        {currentTask.status === 'uploading' && (
          <div className="mt-3 h-1.5 rounded-full bg-muted overflow-hidden">
            <div
              className="h-full rounded-full gold-gradient transition-[width] duration-300 ease-out"
              style={{ width: `${currentTask.progress}%` }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default PublishProgress;
